import { useEffect, useReducer } from 'react'
import { Form, message } from 'antd'
import { AnyAction } from 'redux'
import { GET_BUSINESSINFO } from '../../api/BrandApi'
import {
  GetLocalStorage,
  getSupplierId,
  isResponseCodeSuccess,
} from '../../tools/util'
import { imgFile } from './components/uploadLIC/uploadimg'

// action 类型定义
const BRANDLIST_ACTION_TYPE = {
  CHANGE_TABLEDATA: 'BRANDLIST/CHANGE_TABLEDATA', // 获取数据
  CHANGE_PIC: 'BRANDLIST/CHANGE_PIC',
  CHANGE_PAGE: 'BRANDLIST/CHANGE_PAGE',
  CHANGE_LOADINGPAGE: 'BRANDLIST/CHANGE_LOADINGPAGE',
  CHANGE_LOADING: 'BRANDLIST/CHANGE_LOADING',
}
interface AllocationAddState {
  loading: boolean
  pictures: Array<any>
  productCode: string
  data: Array<any>
  enterpriseLevelState: boolean
  licenceList: any[]
  pageData: { pageNo: number; pageSize: number }
  agreementList: any[]
  uploadParams: { code: string; type: string }
}
// 默认数据
const defaultState: AllocationAddState = {
  loading: true,
  pictures: [],
  productCode: '',
  data: [],
  enterpriseLevelState: false,
  licenceList: [],
  agreementList: [],
  pageData: {
    pageNo: 1,
    pageSize: 10,
  },
  uploadParams: {
    code: GetLocalStorage('SUPPLIER_CODE'),
    type: 'supplier',
  },
}
const reducer = (state = defaultState, action: AnyAction) => {
  const arr = { ...state }
  switch (action.type) {
    case BRANDLIST_ACTION_TYPE.CHANGE_PIC:
      arr.pictures = action.value
      return arr
    case BRANDLIST_ACTION_TYPE.CHANGE_PAGE:
      arr.pageData = action.value
      return arr
    case BRANDLIST_ACTION_TYPE.CHANGE_LOADING:
      arr.loading = action.value
      return arr
    default:
      return state
  }
}

// 设置图片
const changepicAction = (params: imgFile[]) => ({
  type: BRANDLIST_ACTION_TYPE.CHANGE_PIC,
  value: params,
})

const changLoading = (params: boolean) => ({
  type: BRANDLIST_ACTION_TYPE.CHANGE_LOADING,
  value: params,
})

const useBusinessHooks = () => {
  const [statepages, dispatch] = useReducer(reducer, defaultState)

  const {
    loading,
    pictures,
    productCode,
    data,
    uploadParams,
    enterpriseLevelState,
    licenceList,
    agreementList,
  } = statepages
  const [form] = Form.useForm()

  useEffect(() => {
    getBusiness()
    // eslint-disable-next-line
  }, [])

  // 获取工商信息
  const getBusiness = async () => {
    const res = await GET_BUSINESSINFO({
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(changLoading(false))
      if (res.data.licenceUrl !== '') {
        const imgData = {
          url: res.data.licenseUrl,
          baseUrl: res.data.baseUrl,
        }
        dispatch(changepicAction([imgData]))
      } else {
        dispatch(changepicAction([]))
      }
      const startDate = res.data.startDate || '-'
      const endDate = res.data.endDate || '-'
      const enterpriseNature = res.data.enterpriseNature
        ? res.data.enterpriseNature.split(',')
        : null
      form.setFieldsValue({
        ...res.data,
        enterpriseNature,
        allDate: startDate + ' 至 ' + endDate,
      })
    } else {
      message.warning(`${res.msg}`)
    }
  }
  return {
    form,
    loading,
    pictures,
    productCode,
    data,
    uploadParams,
    enterpriseLevelState,
    licenceList,
    agreementList,
  }
}

export default useBusinessHooks
import { useEffect, useReducer } from 'react'
import { Form, message } from 'antd'
import { AnyAction } from 'redux'
import { GET_BUSINESSINFO } from '../../api/BrandApi'
import {
  GetLocalStorage,
  getSupplierId,
  isResponseCodeSuccess,
} from '../../tools/util'
import { imgFile } from './components/uploadLIC/uploadimg'

// action 类型定义
const BRANDLIST_ACTION_TYPE = {
  CHANGE_TABLEDATA: 'BRANDLIST/CHANGE_TABLEDATA', // 获取数据
  CHANGE_PIC: 'BRANDLIST/CHANGE_PIC',
  CHANGE_PAGE: 'BRANDLIST/CHANGE_PAGE',
  CHANGE_LOADINGPAGE: 'BRANDLIST/CHANGE_LOADINGPAGE',
  CHANGE_LOADING: 'BRANDLIST/CHANGE_LOADING',
}
interface AllocationAddState {
  loading: boolean
  pictures: Array<any>
  productCode: string
  data: Array<any>
  enterpriseLevelState: boolean
  licenceList: any[]
  pageData: { pageNo: number; pageSize: number }
  agreementList: any[]
  uploadParams: { code: string; type: string }
}
// 默认数据
const defaultState: AllocationAddState = {
  loading: true,
  pictures: [],
  productCode: '',
  data: [],
  enterpriseLevelState: false,
  licenceList: [],
  agreementList: [],
  pageData: {
    pageNo: 1,
    pageSize: 10,
  },
  uploadParams: {
    code: GetLocalStorage('SUPPLIER_CODE'),
    type: 'supplier',
  },
}
const reducer = (state = defaultState, action: AnyAction) => {
  const arr = { ...state }
  switch (action.type) {
    case BRANDLIST_ACTION_TYPE.CHANGE_PIC:
      arr.pictures = action.value
      return arr
    case BRANDLIST_ACTION_TYPE.CHANGE_PAGE:
      arr.pageData = action.value
      return arr
    case BRANDLIST_ACTION_TYPE.CHANGE_LOADING:
      arr.loading = action.value
      return arr
    default:
      return state
  }
}

// 设置图片
const changepicAction = (params: imgFile[]) => ({
  type: BRANDLIST_ACTION_TYPE.CHANGE_PIC,
  value: params,
})

const changLoading = (params: boolean) => ({
  type: BRANDLIST_ACTION_TYPE.CHANGE_LOADING,
  value: params,
})

const useBusinessHooks = () => {
  const [statepages, dispatch] = useReducer(reducer, defaultState)

  const {
    loading,
    pictures,
    productCode,
    data,
    uploadParams,
    enterpriseLevelState,
    licenceList,
    agreementList,
  } = statepages
  const [form] = Form.useForm()

  useEffect(() => {
    getBusiness()
    // eslint-disable-next-line
  }, [])

  // 获取工商信息
  const getBusiness = async () => {
    const res = await GET_BUSINESSINFO({
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(changLoading(false))
      if (res.data.licenceUrl !== '') {
        const imgData = {
          url: res.data.licenseUrl,
          baseUrl: res.data.baseUrl,
        }
        dispatch(changepicAction([imgData]))
      } else {
        dispatch(changepicAction([]))
      }
      const startDate = res.data.startDate || '-'
      const endDate = res.data.endDate || '-'
      const enterpriseNature = res.data.enterpriseNature
        ? res.data.enterpriseNature.split(',')
        : null
      form.setFieldsValue({
        ...res.data,
        enterpriseNature,
        allDate: startDate + ' 至 ' + endDate,
      })
    } else {
      message.warning(`${res.msg}`)
    }
  }
  return {
    form,
    loading,
    pictures,
    productCode,
    data,
    uploadParams,
    enterpriseLevelState,
    licenceList,
    agreementList,
  }
}

export default useBusinessHooks
